import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IoLocationSharp } from "react-icons/io5";
import './HeaderTop.css';
import LanguageDropdown from '../../LanguageDropdown/LanguageDropdown.js';
import { usePublicSettings } from '../../../context/PublicSettingsContext.js';
import { formatPublicAddressSingleLine } from '../../../utils/formatPublicAddress.js';

function HeaderTop () {
    const { t } = useTranslation();
    const { publicSettings } = usePublicSettings();
    const [headerTopVisible, setHeaderTopVisible] = useState(true);

    const headerAddress = formatPublicAddressSingleLine(publicSettings?.address) || t('header.addressFallback');

    useEffect(() => {
        const handleScroll = () => {
            const header = document.getElementById('header');
            if (!header) return;

            const scrollY = window.pageYOffset;

            if (scrollY >= 80) {
                header.classList.add('scroll-header');
                setHeaderTopVisible(false);
            } else {
                header.classList.remove('scroll-header');
                setHeaderTopVisible(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={`header-top  ${headerTopVisible ? '' : 'hidden'}`}>
            <div className='header-top-content container'>
                <LanguageDropdown />

                <p className='header-top-address'>
                    <IoLocationSharp className='ht-address-icon'/>
                    {headerAddress}
                </p>
            </div>
        </div>
    );
}

export default HeaderTop;
